// branchRoutes.js
import BranchAdminDashboard from "views/branchAdmin/BranchAdminDashboard";
import BranchUsersPage from "views/branchAdmin/BranchUsersPage";
import WithdrawalApprovalPage from "views/branchAdmin/WithdrawalApprovalPage";
import Profile from "views/examples/Profile";
import Inventory from "views/stockManager/Inventory";
import Movements from "views/stockManager/Movements";
import Purchases from "views/stockManager/Purchases";
import MyLeaveRequests from "views/Rh/MyLeaveRequests";

const branchRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: <BranchAdminDashboard />,
    layout: "/branch",
    sidebar: true,               // will appear in the sidebar
  },
  {
  path: "/users",
  name: "Users",
  icon: "ni ni-single-02 text-info",
  component: <BranchUsersPage />,
  layout: "/branch",
  sidebar: true,
},
{
    path: "/profile",
    name: "User Profile",
    icon: "ni ni-single-02 text-yellow",
    component: <Profile />,
    layout: "/branch",
  },
  {
  path: "/inventory",
  name: "Inventory",
  icon: "ni ni-tag text-success",
  component: <Inventory />,
  layout: "/branch",
  sidebar: true,
},
{
  path: "/movements",
  name: "Movements",
  icon: "ni ni-bullet-list-67 text-info",
  component: <Movements />,
  layout: "/branch",
  sidebar: true,
},
{
  path: "/purchases",
  name: "Purchases",
  icon: "ni ni-cart text-warning",
  component: <Purchases />,
  layout: "/branch",
  sidebar: true,
},
{
  path: "/withdrawals",
  name: "Withdrawal Approvals",
  icon: "ni ni-money-coins text-warning",
  component: <WithdrawalApprovalPage />,
  layout: "/branch",
  sidebar: true,
},
{
      path: "/my-leaves",
      name: "My Leave Requests",
      icon: "ni ni-calendar-grid-58",
      component: <MyLeaveRequests />,
      layout: "/branch",
      sidebar: true,
    },
  // Add more routes here, e.g.:
  // { path: "/stock", name: "Stock", icon: "ni ni-tag text-info", component: <StockPage />, layout: "/branch", sidebar: true },
];

export default branchRoutes;